import { render, staticRenderFns } from "./SetHots.vue?vue&type=template&id=c0f57f04&scoped=true&"
import script from "./SetHots.vue?vue&type=script&lang=js&"
export * from "./SetHots.vue?vue&type=script&lang=js&"
import style0 from "./SetHots.vue?vue&type=style&index=0&id=c0f57f04&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0f57f04",
  null
  
)

export default component.exports